import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './sanolivar-style.css';

import Name from './utils/Name.js';

// import components
import Header from './components/Header.jsx';
import Slider from './components/Slider.jsx';
import Form from './components/Form.jsx';
import Footer from './components/Footer.jsx';
import Chatbot from './components/Chatbot.jsx';
import { assets, root } from './utils/Path.js';

const assetsIoT = `${assets}/images/iot/`;

const sliderContent = [
  {
    name: 'Caso de uso - General',
    url: `${assets}images/casos-iot/focus-general.webp`,
  },
  {
    name: 'Caso de uso - Agroindustria',
    url: `${assets}images/casos-iot/focus-agro.webp`,
  },
  {
    name: 'Caso de uso - Industrial',
    url: `${assets}images/casos-iot/focus-industrial.webp`,
  },
  {
    name: 'Caso de uso - Salud',
    url: `${assets}images/casos-iot/focus-salud.webp`,
  }
];

createRoot(document.getElementById('iot')).render(
  <StrictMode>
    <Header active={"Innovación & Servicios"} />
    {/* BANNER */}
    <section className="banner endark">
      <div className="background">
        <video loading="lazy" autoPlay muted loop src={'./assets/videos/banner-iot.mp4'}></video>
      </div>
      <div>
        <h1>Soluciones IoT Personalizadas</h1>
        <p className='stretch centered'>Creemos que el futuro de la tecnología está en la conexión inteligente de dispositivos, datos y personas. El Internet de las Cosas (IoT) es la clave para transformar industrias, mejorar la eficiencia operativa y ofrecer soluciones innovadoras que impulsen un mundo más interconectado.</p>
      </div>
    </section>

    <section className="compressed dark">
      <h2 data-aos="fade-up">Nuestras Soluciones IoT</h2>
      <p data-aos="fade-up" className='stretch centered'>Ofrecemos soluciones IoT personalizadas para satisfacer las necesidades específicas de su negocio. Nuestras plataformas y dispositivos IoT están diseñados para:</p>
      <div className="exposer inner" data-aos="fade-left">
        <div className="card-expo flow">
          <img loading="lazy" src={`${assetsIoT}monitoreo.webp`} alt='Circuito electrónico' aria-label='Circuito electrónico' title='Circuito electrónico' />
          <div>
            <h3>Monitoreo y Control</h3>
            <p>Supervise operaciones en tiempo real desde cualquier lugar con nuestros dispositivos IoT.</p>
          </div>
        </div>
        <div className="card-expo flow">
          <img loading="lazy" src={`${assetsIoT}optimizacion.webp`} alt='Escritorio con componentes electrónicos' aria-label='Escritorio con componentes electrónicos' title='Escritorio con componentes electrónicos' />
          <div>
            <h3>Optimización de Recursos</h3>
            <p>Mejore la eficiencia y reduzca costos mediante análisis avanzado y automatización de procesos.</p>
          </div>
        </div>
        <div className="card-expo flow">
          <img loading="lazy" src={`${assetsIoT}seguridad.webp`} alt='Router con seguridad.' aria-label='Router con seguridad.' title='Router con seguridad.' />
          <div>
            <h3>Seguridad IoT</h3>
            <p>Aumente la seguridad de sus operaciones con nuestras soluciones IoT personalizadas y efectivas.</p>
          </div>
        </div>
      </div>
      <div className="exposer inner stretch" data-aos="fade-right">
        <div className="card-expo flow">
          <img loading="lazy" src={`${assetsIoT}cumplimiento.webp`} alt='Chip electrónico' aria-label='Chip electrónico' title='Chip electrónico' />
          <div>
            <h3>Seguridad y Cumplimiento</h3>
            <p>Asegure la integridad de sus datos y operaciones con soluciones que cumplen con los más altos estándares de seguridad.</p>
          </div>
        </div>
        <div className="card-expo flow">
          <img loading="lazy" src={`${assetsIoT}flexibilidad.webp`} alt='Smart Hub' aria-label='Smart Hub' title='Smart Hub' />
          <div>
            <h3>Integración Flexible</h3>
            <p>Nuestras soluciones IoT se integran fácilmente con sistemas existentes, lo que permite una implementación rápida y sin complicaciones.</p>
          </div>
        </div>
      </div>
    </section>

    <section className='compressed c2'>
      <div data-aos="fade-right">
        <h2>Áreas de Aplicación</h2>
        <p>Nuestro enfoque en IoT abarca una amplia variedad de sectores, incluyendo:</p>
        <ul>
          <li><strong>Agricultura Inteligente: </strong>Monitoreo de cultivos y gestión de recursos hídricos para maximizar la productividad y sostenibilidad.</li>
          <li><strong>Manufactura: </strong>Optimización de procesos y mantenimiento predictivo para mejorar la eficiencia y reducir tiempos de inactividad.</li>
          <li><strong>Salud: </strong>Dispositivos médicos conectados que mejoran la atención al paciente y facilitan el seguimiento de la salud en tiempo real.</li>
          <li><strong>Hogar Inteligente: </strong>Automatización del hogar para un mayor confort, seguridad y ahorro energético.</li>
        </ul>
        <button><a role='navigation' title='Ir al apartado de Contacto' href="#contacto"></a>Contáctanos</button>
      </div>
      <div id='card-iot' shake='true' shake-perspective='1600' shake-floating='true' shake-angle='30' shake-glow='true' shake-shadow='true'>
        <img loading="lazy" src={`${assetsIoT}agroindustria.webp`} alt='Cultivo de hortalizas' aria-label='Cultivo de hortalizas' title='Cultivo de hortalizas' />
        <div data-aos="fade-left" shake-depth='2' className="overlay cc2">
          <span shake-depth='3'>150+</span>
          <p shake-depth='4'>Tecnología avanzada</p>
          <span shake-depth='3'>15</span>
          <p shake-depth='4'>Clientes satisfechos</p>
        </div>
      </div>
    </section>
    <section className="compressed bg-alt centered">
      <Slider content={
        <div>
          {
            sliderContent.map(c=>(
              <div key={c.name}>
                <h2>{c.name}</h2>
                <img loading="lazy" src={c.url} alt={c.name} aria-label={c.name} title={c.name}/>
              </div>
            ))
          }
        </div>
      } customClass="full" />
    </section>

    <section className="compressed">
      <h2 data-aos="fade-up">Proyectos IoT</h2>
      <p data-aos="fade-up" className='stretch centered'>Soluciones personalizadas para optimizar y controlar su negocio.</p>
      <div className="c2 big-gap">
        <div data-aos="fade-right">
          <img loading="lazy" src={`${assetsIoT}monitoreo-remoto.webp`} alt='Persona interactuando con múltiples servicios en su computadora' aria-label='Persona interactuando con múltiples servicios en su computadora' title='Persona interactuando con múltiples servicios en su computadora' />
          <h3>Monitoreo Remoto</h3>
          <p className='centered'>Acceso a datos en tiempo real desde cualquier lugar.</p>
        </div>
        <div data-aos="fade-left">
          <img loading="lazy" src={`${assetsIoT}eficiencia-operativa.webp`} alt='Portátil produciendo dinero' aria-label='Portátil produciendo dinero' title='Portátil produciendo dinero' />
          <h3>Eficiencia Operativa</h3>
          <p className='centered'>Reducción de costos mediante análisis avanzado de datos.</p>
        </div>
        <div data-aos="fade-left">
          <img loading="lazy" src={`${assetsIoT}seguridad-iot.webp`} alt='Teléfono móvil y portátil conectados de manera segura' aria-label='Teléfono móvil y portátil conectados de manera segura' title='Teléfono móvil y portátil conectados de manera segura' />
          <h3>Seguridad IoT</h3>
          <p className='centered'>Protección de datos y operaciones en tiempo real.</p>
        </div>
        <div data-aos="fade-right">
          <img loading="lazy" src={`${assetsIoT}automatizacion-total.webp`} alt='Dispositivos comprometidos con el cuidado ambiental' aria-label='Dispositivos comprometidos con el cuidado ambiental' title='Dispositivos comprometidos con el cuidado ambiental' />
          <h3>Automatización Total</h3>
          <p className='centered'>Optimización de recursos para mejorar la productividad.</p>
        </div>
      </div>
    </section>

    <section className="compressed">
      <h2 data-aos="fade-up">¿Por qué Elegir a {Name}?</h2>
      <p data-aos="fade-up" className='stretch'>Con años de experiencia en la implementación de soluciones IoT, SANOLIVAR se ha posicionado como un líder en el campo, ayudando a empresas de todos los tamaños a transformar su forma de operar. Nos enorgullecemos de ofrecer:</p>
      <div className="exposer inner" data-aos="fade-down">
        <div className='card-expo flow start'>
          <img loading="lazy" src={`${assetsIoT}tech.webp`} alt='Persona interactuando en realidad aumentada' aria-label='Persona interactuando en realidad aumentada' title='Persona interactuando en realidad aumentada' />
          <div>
            <div>
              <h3>Tecnología de Vanguardia</h3>
              <p>Desarrollamos soluciones con la tecnología más avanzada para garantizar que su negocio esté a la vanguardia de la innovación</p>
            </div>
          </div>
        </div>
        <div className='card-expo flow start'>
          <img loading="lazy" src={`${assetsIoT}support.webp`} alt='Equipo de trabajo juntando sus manos' aria-label='Equipo de trabajo juntando sus manos' title='Equipo de trabajo juntando sus manos' />
          <div>
            <div>
              <h3>Soporte Integral</h3>
              <p>Desde la planificación hasta la implementación y el soporte continuo, estamos con usted en cada paso del camino</p>
            </div>
          </div>
        </div>
        <div className='card-expo flow start'>
          <img loading="lazy" src={`${assetsIoT}scalability.webp`} alt='Portatil y documentos empresariales' aria-label='Portatil y documentos empresariales' title='Portatil y documentos empresariales' />
          <div>
            <div>
              <h3>Soluciones Escalables</h3>
              <p>Ya sea que esté comenzando con IoT o expandiendo sus operaciones, nuestras soluciones están diseñadas para crecer con su negocio</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* <section className='fw bg-alt'>
      <h2 data-aos="fade-up">Opiniones de nuestros clientes</h2>
      <Slider content={
        <div data-aos="fade-left">
          <div className='witness stars5'>
            <p>Gracias a la solución de HPE, hemos optimizado nuestros procesos de IA y mejorado la eficiencia operativa en poco tiempo.</p>
            <div>
              <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
              <span>Ana López</span>
              <p>Barcelona</p>
            </div>
          </div>
          <div className='witness stars4'>
            <p>La nube privada de HPE ha acelerado nuestra implementación de IA de manera impresionante.</p>
            <div>
              <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
              <span>Carlos Ruiz</span>
              <p>Madrid</p>
            </div>
          </div>
          <div className='witness stars4'>
            <p>La nube privada de HPE ha acelerado nuestra implementación de IA de manera impresionante.</p>
            <div>
              <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
              <span>Carlos Ruiz</span>
              <p>Madrid</p>
            </div>
          </div>
        </div>
      } customClass={'compressed'} />
    </section> */}
    <Form
      title={'Soluciones IoT (Internet de las Cosas)'}
      content={'El Internet de las Cosas no es solo el futuro, es el presente. Descubra cómo nuestras soluciones IoT pueden transformar su negocio y llevarlo al siguiente nivel. Contáctenos hoy para obtener más información.'}
      img={{ src: `${assetsIoT}contacto.webp`, alt: 'Oficina desde casa' }}
      form={[
        {
          label: 'Nombre contacto',
          type: 'text',
          id: 'nombre',
          placeholder: 'Ingrese su nombre aquí'
        },
        {
          label: 'Correo electrónico',
          type: 'email',
          id: 'email',
          placeholder: 'Ingrese su correo aquí'
        },
        {
          label: 'Mensaje',
          type: 'textarea',
          id: 'mensaje',
          placeholder: 'Déjanos un mensaje aquí'
        },
        {
          label: 'Enviar Mensaje',
          type: 'submit',
          id: 'submit',
        }
      ]}
      redirect={`${root}servicios-iot.html`}
    />
    <Footer />
    <Chatbot />
  </StrictMode>
)
